import { render, staticRenderFns } from "./ArrowForward.vue?vue&type=template&id=3ede3fa4&"
import script from "./ArrowForward.vue?vue&type=script&lang=ts&"
export * from "./ArrowForward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports